export default "__VITE_ASSET__3277c6e8__"